import React, { useEffect, useState } from 'react';
import ExoForm from '../exo/ExoForm';
import { useTranslation } from 'react-i18next';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import EditNoteIcon from '@mui/icons-material/EditNote';
import Cookies from 'universal-cookie';
import * as Yup from 'yup';

export const NewTask = ({
  targetType,
  targetId,
  onClose,
  startData,
  onChange,
  onCreate,
  onFeedback,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const cookies = new Cookies();
  const userId = cookies.get('userId');

  const [startDataCollection, setStartDataCollection] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    var newStartData = startData || {};
    if (!newStartData.user) newStartData.user = { id: userId };
    setStartDataCollection(newStartData);
  }, [startData]);

  const fields = [
    {
      label: t('What') + '?',
      key: 'type',
      type: 'smallIconCards',
      cards: [
        {
          label: t('call'),
          Icon: LocalPhoneIcon,
          value: 'call',
        },
        {
          label: t('E-Mail'),
          Icon: EmailIcon,
          value: 'email',
        },
        {
          label: t('Other'),
          Icon: EditNoteIcon,
          value: 'other',
        },
      ],
    },
    {
      label: t('Name'),
      key: 'name',
      type: 'text',
    },
    {
      label: t('Description'),
      key: 'description',
      type: 'richTextEditor',
    },
    {
      label: t('Responsible Employee'),
      key: 'user',
      type: 'user',
    },
    {
      label: t('Reminder'),
      key: 'reminders',
      type: 'reminder',
    },
  ];

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(t('Is required')),
    type: Yup.string().required(t('Is required')),
    user: Yup.object()
      .shape({ id: Yup.string().required(t('Is required')) })
      .required(),
  });

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);

    const reqData = { ...data, targetType, target: { id: targetId } };

    DBRequest({
      config,
      path: isUpdate ? `user-tasks/${data.id}` : `user-tasks`,
      method: isUpdate ? API_PATCH(reqData) : API_POST(reqData),
      onResponse: (res) => handleResponse(res, isUpdate),
      onFeedback,
      onLoading: setIsLoading,
    });
  }

  function handleResponse(data, isUpdate) {
    onClose();
    if (isUpdate) onChange(data);
    else onCreate(data);
  }

  return (
    <ExoForm
      header={startData && startData.id ? t('Update Task') : t('Create Task')}
      fields={fields}
      onSubmit={handleSubmit}
      isLoading={isLoading}
      onCancel={onClose}
      startDataCollection={startDataCollection}
      noDifferences
      validationSchema={validationSchema}
    />
  );
};
